import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { FullCourseSubject } from '../../../typings/api/models';

export function getCoursesSubjectsByTeam(teamId: number): Promise<Array<FullCourseSubject>> {
    const { apiGetCoursesSubjectsByTeam } = apiConfig.getStaticUrls();

    return getFetch(apiGetCoursesSubjectsByTeam, { team: teamId });
}
